export default "__VITE_ASSET__CyJ1lXI4__"